import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Footer = () => {
  const theme = useTheme();
  return (
    <Box sx={{ py: 3, px: 5, backgroundColor: 'primary.main', color: 'white', height: `${theme.footerHeight}px)`}}>
      <Typography variant="body1" align="center">
         &copy; {new Date().getFullYear()} Deloitte Global Services Limited
      </Typography>
    </Box>
  );
};

export default Footer;